module.exports = __webpack_public_path__ + "img/4_163.338caed6.png";